import { NpCategoryFeatures } from "src/components/category/NpCategoryFeatures"
import { useProductContext } from "../context"

export const ProductCategoryFeatures = () => {
  const { categoryFeatures } = useProductContext()

  if (!categoryFeatures) {
    return null
  }

  return <NpCategoryFeatures features={categoryFeatures} maxDisplayed={6} />
}
